<template>
<div>
    <h2 class="font-italic">Login:</h2>
    <form @submit.prevent="login">
        <div class="form-group">
            <label for="email" class="sr-only">Email</label>
            <input v-model="email" type="text" class="form-control" :class="{ 'is-invalid': $v.email.$error }"  id="email" placeholder="Email">
            <div class="invalid-feedback" v-if="!$v.email.required">Field is required</div>
        </div>       

        <div class="form-group">
            <label for="password" class="sr-only">Password</label>
            <input v-model="password" type="password" class="form-control" :class="{ 'is-invalid': $v.password.$error }"  id="password" placeholder="Password">
            <div class="invalid-feedback" v-if="!$v.password.required">Field is required</div>
        </div>
        
        <div class="row-btn">
            <button type="submit" class="btn btn-primary">Login</button>
        </div>
        <div class="text-center">
            <router-link to="/lost-password" class="btn btn-link" title="Lost password">Forgot Password</router-link>
        </div>
    </form>
</div>
</template>

<script>
// @ is an alias to /src
import { required  } from 'vuelidate/lib/validators'


export default {
    name: 'Login',
    created(){
        window.localStorage.clear();
    },
    data(){
        return {
            email : "",
            password : ""
        }
    },
    validations: {
        email: {
            required,
        },
        password: {
            required,
        }
    },
    methods: {
      login: function () {
        this.$v.$touch()
        if (this.$v.$invalid) {
            return false;
        }

        let username = this.email 
        let password = this.password
        const v = this;

        this.$store.dispatch('login', { username, password })
            .then(() => {
                if(!this.$store.getters.privacyAccepted){
                    this.$router.push('/privacy')
                }
                else if(!this.$store.getters.privacyCgaAccepted){
                    this.$router.push('/privacy/cga')
                } 
                else {
                    this.$router.push('/')
                }                
            })
            .catch(err => {                
                this.password = ""
                v.$emit('show-message', {
                    type: 'danger',
                    text: err.response.data.message
                });
            });
      }
    }
}
</script>